import { atom } from 'jotai'

/**
 * Tracks which custom field keys the user has added as columns in the billing
 * schedule list view. Read by the CSV export button so the exported file
 * includes the same custom field columns as the on-screen table.
 */
export const selectedCustomFieldColumnsAtom = atom<string[]>([])

/**
 * Mirror of the active custom field equality filters in the billing schedule
 * list view (key → value). Read by the CSV export button so the exported file
 * applies the same filters as the on-screen table.
 */
export const selectedCustomFieldFiltersAtom = atom<Record<string, string>>({})
